import {Navigate, useLocation} from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
import UserService from "../../Service/UserService";
import TokenService from "../../Service/TokenService";

// export const ProtectedRoute = ({ children }) => {
//     const { user } = useAuth();
//     if (!user) {
//         // user is not authenticated
//         return <Navigate to="/login" />;
//     }
//     return children;
// };

export const ProtectedRoute = ({ element: Component,  requiredRole: String }) => {
    const location = useLocation();
    const userRole = TokenService.getRole(); // Получаем роль пользователя

    return UserService.isAuthenticated() ?(
        Component
    ):(
        <Navigate to={"/login"} replace state={{from: location}}/>
    )
    // if (!UserService.isAuthenticated()) {
    //     console.log("User -- Navigate" + !UserService.isAuthenticated())
    //     return <Navigate to="/login" replace state={{ from: location }} />;
    // }
    // console.log("here")

}

// export const AdminRoute = ({ element: Component }) => {
//     const location = useLocation();
//
//     return UserService.isAdmin() ?(
//         Component
//     ):(
//         <Navigate to={"/login"} replace state={{from: location}}/>
//     )
// }